import React from 'react';
import { ProductionPiece } from 'app/models/ProductionPiece';
import { pieceRefWithProductionPiece } from 'app/pages/ToursPage/tourHelpers';
import { getPickingDescription } from './getPickingDescription';
import { aggregatePiecesByReference } from './aggregatePiecesByReference';

interface Props {
  pieces: ProductionPiece[];
  title?: string;
  productName?: string;
  forceDrawerHardwareSorting?: boolean;
  preserveOrder?: boolean;
  showPickingAddress?: boolean;
}

const PickingSectionView = ({
  pieces,
  title,
  productName,
  forceDrawerHardwareSorting = false,
  preserveOrder = false,
  showPickingAddress = true,
}: Props) => {
  if (!pieces || pieces.length === 0) {
    return null;
  }

  const aggregatedPieces = aggregatePiecesByReference(pieces, {
    forceDrawerHardwareSorting,
    preserveOrder,
  });

  return (
    <div>
      {productName && (
        <div className="flex ml-4 mt-3 mb-1">
          <div className="text-xl">{productName}</div>
        </div>
      )}
      {title && !productName && (
        <div className="flex ml-4 mt-2 mb-1">
          <div className="text-xl">{title}</div>
        </div>
      )}
      <div>
        {aggregatedPieces.map(piece => (
          <div
            key={piece.id}
            className="flex text-lg border-b border-gray-800 my-1"
          >
            <div className="border h-6 w-6 border-gray-800 mr-2" />
            {showPickingAddress && !piece.cutting && (
              <div className="w-20 shrink-0 text-lg font-bold mr-1 whitespace-nowrap overflow-hidden">
                {piece.pickingAddresses[0] || ''}
              </div>
            )}
            <div className="w-12 shrink-0 font-bold">{piece.quantity}</div>
            <div className="w-28 shrink-0 text-base">
              {pieceRefWithProductionPiece(piece)}
            </div>
            <div className="border h-6 w-6 border-gray-800 mx-2" />
            <div
              className="flex-1"
              dangerouslySetInnerHTML={{
                __html: getPickingDescription(piece),
              }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export default PickingSectionView;
